import React from 'react';
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from 'react-bootstrap';
import m2r2logo from '../../assets/icons/m2r2logo.svg';
import InstagramIcon from '../../assets/icons/InstagramIcon.svg';
import LinkedinIcon from '../../assets/icons/LinkedinIcon.svg';
import TwitterIcon from '../../assets/icons/TwitterIcon.svg';
import YoutubeIcon from '../../assets/icons/YoutubeIcon.svg';
import Derbylocation from '../../assets/icons/Derbylocation.png';
import Indialocation from '../../assets/icons/Indialocation.png';
// import RequestDemo from '../pages/RequestDemo/RequestDemo';
import './style.css';

const Footer = () => {
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
        window.scrollTo({
            top: section.offsetTop,
            behavior: 'smooth' // Make the scrolling smooth
        });
    }
  }
 
  return (
    <Container fluid className="Container">
      
      <Row className='Footer'>
        <Col>
        <Row className='Firstrow'>
      <Col xs={12} md={3}>
        <img src={m2r2logo} alt="m2r2logo" className="img-fluid" />
      </Col>
      <Col xs={12} md={9}>
        <Row className='Secondrow'>
          <Col xs={6} sm={2}>
            <div className='Footermenu' onClick={()=>{navigate('/')}}>Home</div>
          </Col>
          <Col xs={6} sm={2}>
            <div className='Footermenu' onClick={() => scrollToSection('bossMagicSection')}>Boss Magic</div>
          </Col>
          <Col xs={6} sm={2}>
            <div className='Footermenu' onClick={() => scrollToSection('keyFeaturesSection')}>Key Features</div>
          </Col>
          <Col xs={6} sm={2}>
            <div className='Footermenu' onClick={() => scrollToSection('pricingSection')}>Pricing</div>
          </Col>
          <Col xs={12} sm={2}>
            <div className='Footermenu' onClick={() => scrollToSection('bossMagicSection')}>Book a Demo</div>
          </Col>
          <Col xs={12} sm={2}>
            <div className='Footermenu'onClick={() => scrollToSection('contactusSection')}>Contact us</div>
          </Col>
        </Row>
      </Col>
    </Row>
          <hr />
          <div className='Secondrow'>
            <Col xs={12} md={6}>
              <div className='Location'>
                <h3>UK Office</h3>
                <p>Suite No. 3.4, Litchurch Plaza, Litchurch Lane, Derby, Derbyshire, DE24 8AA, United Kingdom</p>
                <div className='SocialIcons'>
                  <img src={InstagramIcon} alt="Instagram" className='social-icon'/>
                  <img src={LinkedinIcon} alt="LinkedIn" className='social-icon'/>
                  <img src={TwitterIcon} alt="Twitter" className='social-icon'/>
                  <img src={YoutubeIcon} alt="Youtube" className='social-icon'/>
                </div>
                <img src={Derbylocation} alt="derbylocation" className='LocationImage' />
              </div>
            </Col>
            <Col xs={12} md={6}>
              <div className='Location'>
                <h3>India Office</h3>
                <p>53/3, Celebrity Paradise Main St, Doddathoguru, Electronics City Phase 1, Bengaluru, KA 560100, India</p>
                <div className='SocialIcons'>
                  <img src={InstagramIcon} alt="Instagram" className='social-icon'/>
                  <img src={LinkedinIcon} alt="LinkedIn" className='social-icon'/>
                  <img src={TwitterIcon} alt="Twitter" className='social-icon'/>
                  <img src={YoutubeIcon} alt="Youtube" className='social-icon'/>
                </div>
                <img src={Indialocation} alt="indialocation" className='LocationImage' />
              </div>
            </Col>
          </div>
          <hr />
          <Row className='Thirdrow'>
            <Col xs={12} md={9}>
              <div className='Footerpolicies'>
              <div><a href="/termsofuse">Terms of Use</a></div>
              <div><a href="/cookiepolicy">Cookie policy</a></div>
              <div><a href="/privacypolicy">Privacy policy</a></div>
              <div><a href="/itsecuritypolicies">IT Security Policies</a></div>
              </div>
            </Col>
            <Col xs={12} md={3}>
              <p className="text-md-right">@2024 M2R2. All Rights Reserved.</p>
            </Col>
          </Row>
        </Col>
      </Row>
      {/* {showRequestDemo && (
        <RequestDemo onCancelRequest={handleCancelRequest} />
      )} */}
    </Container>
  );
};

export default Footer;
